import isOnDemand from "./isOnDemand"
import moment from "moment-timezone"
import HubSpot from "./HubSpot"
import api from "./api"
import qs from "query-string"

const submitGetInTouch = async ({
  user: { name, email, phone, message },
  isCms,
  space,
  total_price,
  toEmail = null,
}) => {
  const searchParams = qs.parse(
    typeof window !== "undefined" ? window.location.search : ""
  )
  let spaceType = searchParams.space_type || "CMS Profile"

  if (isOnDemand()) spaceType = "On-demand space"

  let move_in_date = null
  if (searchParams.move_in_date) {
    if (moment(searchParams.move_in_date, "YYYY-MM-DD", true).isValid()) {
      move_in_date = moment(searchParams.move_in_date, "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      )
    } else {
      move_in_date = moment().format("YYYY-MM-DD")
    }
  }

  const data = {
    fullname: name,
    email,
    phone,
    message,
    location_interest_form: space.space_name || space.title,
    team_size: searchParams.team_size || "N/A",
    move_in_date: move_in_date || "N/A",
    space_type: spaceType,
    price: `${total_price || "N/A"}`,
  }

  const formData = {
    email,
    toEmail: toEmail || space?.formEmail || "mahesh.samudra@worksimply.com",
    space_id: isCms ? space.locationsUuid : space.id,
    team_size: searchParams.team_size || "N/A",
    is_team_size_set: typeof searchParams.team_size !== "undefined",
    formData: [
      { label: "Name", value: name },
      { label: "Email", value: email },
      { label: "Phone number", value: phone },
      { label: "Message", value: message || "N/A" },
      { label: "Location", value: space.space_name || space.title },
      { label: "Team Size", value: searchParams.team_size || "N/A" },
      { label: "Searched Move-in Date", value: move_in_date || "N/A" },
      { label: "Space Type", value: spaceType },
      { label: "Price", value: `${total_price || "N/A"}` },
    ],
  }

  let emailSubject = "Location Profile Page"

  if (space.title) {
    emailSubject = `Workplace One ${space.title}`
  }
  if (space.space_name) {
    emailSubject = `${space.space_name}`
  }

  await HubSpot(
    "207bd8fc-b2ed-4852-8a22-b4a09b1207fd",
    data,
    formData,
    document.title || "Location Profile Page",
    `${emailSubject} - Inquiry`
  )

  const customData = {
    userEmail: email,
    space_id: isCms ? space.locationsUuid : space.id,
    team_size: searchParams.team_size || "N/A",
    is_team_size_set: typeof searchParams.team_size !== "undefined",
  }

  // This is only for analytics. This does not submit a form
  if (process.env.NODE_ENV === "production") {
    await api(`handle-form`, customData)
      .then((result) => {
        // do nothing
      })
      .catch((e) => {
        // do nothing
      })
  }

  return true
}

export default submitGetInTouch
